<div [@routerTransition] class="new-theme d-flex flex-column flex-root">
    <div class="page d-flex flex-row flex-column-fluid">

        <div class="d-flex flex-column flex-row-fluid wrapper" id="kt_wrapper">
            <div id="kt_header" class="header align-items-stretch">
                <div class="{{ containerClass }} d-flex align-items-stretch justify-content-between">
                    <!-- begin aside toggler -->
                    <div title="Show aside menu" class="d-flex align-items-center d-lg-none ms-n3 me-1">
                        <div id="kt_aside_mobile_toggle"
                            class="btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px">
                            <span class="icon-Property-3menu"></span>
                            <!---->
                        </div>
                    </div>
                    <!-- end aside toggler-->
                    <!-- begin mobile logo -->
                    <div class="d-flex align-items-center flex-grow-0">
                        <default-logo [customHrefClass]="'d-lg-none'"
                            [skin]="appSession.theme.baseSettings.layout.darkMode ? 'dark-sm': 'light-sm' "></default-logo>
                    </div>
                    <!-- end mobile logo -->
                    <div class="d-flex align-items-stretch justify-content-between flex-grow-1">
                        <div class="d-flex align-items-stretch justify-content-between flex-grow-1">
                            <default-brand class="d-flex align-items-center"></default-brand>

                            <header-search-input class="global-search-input"></header-search-input>

                            <div class="d-flex align-items-stretch flex-shrink-0">
                                <div class="d-flex align-items-stretch flex-shrink-0">
                                    <active-delegated-users-combo
                                        *ngIf="!installationMode"></active-delegated-users-combo>
                                    <subscription-notification-bar></subscription-notification-bar>
                                    <!-- <quick-theme-selection></quick-theme-selection>
                                    <language-switch-dropdown></language-switch-dropdown> -->
                                    <header-notifications></header-notifications>
                                    <!-- <chat-toggle-button></chat-toggle-button>
                                    <toggle-dark-mode
                                        [isDarkModeActive]="isDarkModeActive()"
                                    ></toggle-dark-mode> -->
                                    <user-menu></user-menu>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="kt_page-content">
                <div id="kt_aside" [class]="ui.getLeftAsideClass()" data-kt-drawer="true" data-kt-drawer-name="aside"
                    data-kt-drawer-activate="{default: true, lg: false}" data-kt-drawer-overlay="true"
                    data-kt-drawer-width="{default:'200px', '300px': '250px'}" data-kt-drawer-direction="start"
                    data-kt-drawer-toggle="#kt_aside_mobile_toggle">
                    <div class="aside-menu flex-column-fluid">
                        <div id="kt_aside_menu_wrapper" class="py-5">
                            <side-bar-menu class="hover-scroll-overlay-y"></side-bar-menu>
                        </div>
                    </div>
                </div>
                <div id="kt_main-stage">
                    <div id="kt_main-stage-body">
                        <router-outlet></router-outlet>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
